// extracted by mini-css-extract-plugin
export var standaloneTable = "_gl-0";
export var withExtraHeader = "_gl-1";